module.exports = __webpack_public_path__ + "img/administrar-header.0a820ed2.jpg";